define(["require", "exports", "./analytics", "./number", "./controls/paging-info"], function (require, exports, analytics_1, number_1, paging_info_1) {
    "use strict";
    exports.__esModule = true;
    var autoScroll = function ($box, $item) {
        var overflowX = $box.css('overflowX');
        if (overflowX === 'auto') {
            var curX = $box.scrollLeft();
            var itemX = $item.position().left;
            var boxWidth = $box.width();
            var itemWidth = $item.width();
            var marginLeft = itemX;
            var marginRight = boxWidth - itemX - itemWidth;
            var triggerWidth = boxWidth / 8;
            if (marginLeft < triggerWidth) {
                $box.scrollLeft(Math.max(curX + marginLeft - itemWidth, 0));
            }
            else if (marginRight < triggerWidth) {
                $box.scrollLeft(curX - marginRight + itemWidth);
            }
        }
    };
    var RadioSelect = (function () {
        function RadioSelect($sel, optionSel, $sub, $paging) {
            var _this = this;
            this.$sel = $sel;
            this.optionSel = optionSel;
            this.$sub = $sub;
            this.$paging = $paging;
            this.$selected = this.$sel.find(this.optionSel + ".selected");
            this.$hidden = this.$sel.find('input[type="hidden"]');
            this.$sel.data('optionSel', optionSel);
            this.$sel.on('click', this.optionSel, function (e) {
                analytics_1["default"]('customize', "select_" + _this.$hidden.data('attribute-name'));
                _this.$selected = _this.$sel.find(_this.optionSel + ".selected");
                var selected = _this.$selected.length ? _this.$selected[0] : null;
                var target = e.currentTarget;
                if (selected != target) {
                    $(selected).toggleClass('selected', false);
                    _this.$selected = $(target);
                    _this.$selected.toggleClass('selected', true);
                    var val = number_1.extractFieldAsDecimal(_this.$selected);
                    var $visibles = _this.$sel.find(_this.optionSel + ":visible");
                    var index = $visibles.index(_this.$selected);
                    var total = $visibles.length;
                    number_1.setFieldNumberVal(_this.$hidden, val);
                    if (_this.$sub) {
                        _this.$sub.trigger('radioSelect:change', val);
                        if (!e.isTrigger) {
                            _this.$sub.trigger('radioSelect:selected', _this.$selected);
                        }
                    }
                    autoScroll(_this.$sel, _this.$selected);
                    if (_this.$paging) {
                        _this.$paging.data('cur', index).data('total', total);
                        paging_info_1.renderPaging(_this.$paging);
                    }
                    _this.$hidden.trigger('change');
                }
            });
        }
        return RadioSelect;
    }());
    exports.RadioSelect = RadioSelect;
    function getSelected($sel) {
        var optionSel = $sel.data('optionSel');
        if (!optionSel) {
            return null;
        }
        var $selected = $sel.find(optionSel + ".selected");
        return $selected;
    }
    exports.getSelected = getSelected;
    function toggleRadioSelect($sel, $target) {
        var optionSel = $sel.data('optionSel');
        if (!optionSel) {
            return;
        }
        var $selected = $sel.find(optionSel + ".selected");
        $selected.toggleClass('selected', false);
        $target.toggleClass('selected', true);
    }
    function setRadioSelect($sel, val) {
        var optionSel = $sel.data('optionSel');
        if (!optionSel) {
            return;
        }
        var $target = $sel.find(optionSel + "[data-decimal='" + val + "']");
        toggleRadioSelect($sel, $target);
    }
    exports.setRadioSelect = setRadioSelect;
    function setRadioSelectByTag($sel, tag) {
        var optionSel = $sel.data('optionSel');
        if (!optionSel) {
            null;
        }
        var $target = findRadioSelectOptionByTag($sel, tag);
        toggleRadioSelect($sel, $target);
    }
    exports.setRadioSelectByTag = setRadioSelectByTag;
    function findRadioSelectOptionByTag($sel, tag) {
        var optionSel = $sel.data('optionSel');
        if (!optionSel) {
            null;
        }
        var $target = $sel.find(optionSel).filter(function (i, opt) {
            return $(opt).data('tags').split(',').filter(function (t) { return t === tag; }).length > 0;
        });
        return $target;
    }
    exports.findRadioSelectOptionByTag = findRadioSelectOptionByTag;
    function ensureSelectedInView($sel, $target) {
        if ($target === void 0) { $target = null; }
        $target = $target || $sel.find('.selected');
        if ($target.length) {
            $target[0].scrollIntoView({
                behavior: 'smooth'
            });
        }
    }
    exports.ensureSelectedInView = ensureSelectedInView;
    function controlVisibility($master, $children, sel) {
        $master.change(function (e) {
            var attr = $(e.currentTarget).data('decimal');
            $.each($children, function (i, child) {
                var $child = $(child);
                var childAttr = sel($child);
                if (childAttr == attr) {
                    $child.show();
                }
                else {
                    $child.hide();
                }
            });
        });
        $master.trigger('change');
    }
    exports.controlVisibility = controlVisibility;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/slideSelect.js
// module id = 56
// module chunks = 0